export const ExercisesIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="40"
        height="40"
        rx="10"
        fill="white"
        style={{fill: 'white', fillOpacity: 1}}
      />
      <path
        d="M34.5 9.5H18.5V21.5H28L30 23.5L32 21.5H34.5V9.5Z"
        stroke="url(#paint0_linear_11041_2257)"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M27.558 13.23C27.558 13.054 27.4627 12.8963 27.272 12.757C27.0887 12.6176 26.9017 12.548 26.711 12.548C26.5203 12.548 26.3443 12.592 26.183 12.68C26.0217 12.7606 25.9043 12.8596 25.831 12.977C25.6257 13.2703 25.468 13.417 25.358 13.417C25.0427 13.417 24.885 13.263 24.885 12.955C24.885 12.6763 25.0793 12.394 25.468 12.108C25.8567 11.8146 26.2637 11.668 26.689 11.668C27.2903 11.668 27.767 11.9136 28.119 12.405C28.3097 12.6763 28.405 12.9513 28.405 13.23C28.405 13.714 28.207 14.1796 27.811 14.627C27.6423 14.8176 27.4737 14.9973 27.305 15.166C26.9017 15.5693 26.7 15.837 26.7 15.969C26.7 16.101 26.7513 16.2476 26.854 16.409C26.9493 16.5703 26.997 16.6803 26.997 16.739C26.997 16.7977 26.9787 16.8637 26.942 16.937C26.854 17.069 26.7257 17.135 26.557 17.135C26.3957 17.135 26.2307 17.025 26.062 16.805C25.8933 16.5777 25.809 16.3283 25.809 16.057C25.809 15.5803 25.9887 15.1476 26.348 14.759C26.5167 14.5756 26.6743 14.4216 26.821 14.297C27.3123 13.835 27.558 13.4793 27.558 13.23ZM26.073 18.576C26.073 18.444 26.1207 18.323 26.216 18.213C26.3187 18.103 26.458 18.048 26.634 18.048C26.81 18.048 26.9347 18.081 27.008 18.147C27.0887 18.213 27.129 18.356 27.129 18.576C27.129 18.9647 26.953 19.159 26.601 19.159C26.469 19.159 26.348 19.093 26.238 18.961C26.128 18.829 26.073 18.7007 26.073 18.576Z"
        fill="url(#paint1_linear_11041_2257)"
      />
      <mask
        id="mask0_11041_2257"
        style={{maskType: 'luminance'}}
        maskUnits="userSpaceOnUse"
        x="24"
        y="10"
        width="6"
        height="10"
      >
        <path
          d="M29.5 10.5H24.5V19.5H29.5V10.5Z"
          fill="white"
          style={{fill: 'white', fillOpacity: 1}}
        />
        <path
          d="M27.558 13.23C27.558 13.054 27.4627 12.8963 27.272 12.757C27.0887 12.6176 26.9017 12.548 26.711 12.548C26.5203 12.548 26.3443 12.592 26.183 12.68C26.0217 12.7606 25.9043 12.8596 25.831 12.977C25.6257 13.2703 25.468 13.417 25.358 13.417C25.0427 13.417 24.885 13.263 24.885 12.955C24.885 12.6763 25.0793 12.394 25.468 12.108C25.8567 11.8146 26.2637 11.668 26.689 11.668C27.2903 11.668 27.767 11.9136 28.119 12.405C28.3097 12.6763 28.405 12.9513 28.405 13.23C28.405 13.714 28.207 14.1796 27.811 14.627C27.6423 14.8176 27.4737 14.9973 27.305 15.166C26.9017 15.5693 26.7 15.837 26.7 15.969C26.7 16.101 26.7513 16.2476 26.854 16.409C26.9493 16.5703 26.997 16.6803 26.997 16.739C26.997 16.7977 26.9787 16.8637 26.942 16.937C26.854 17.069 26.7257 17.135 26.557 17.135C26.3957 17.135 26.2307 17.025 26.062 16.805C25.8933 16.5777 25.809 16.3283 25.809 16.057C25.809 15.5803 25.9887 15.1476 26.348 14.759C26.5167 14.5756 26.6743 14.4216 26.821 14.297C27.3123 13.835 27.558 13.4793 27.558 13.23ZM26.073 18.576C26.073 18.444 26.1207 18.323 26.216 18.213C26.3187 18.103 26.458 18.048 26.634 18.048C26.81 18.048 26.9347 18.081 27.008 18.147C27.0887 18.213 27.129 18.356 27.129 18.576C27.129 18.9647 26.953 19.159 26.601 19.159C26.469 19.159 26.348 19.093 26.238 18.961C26.128 18.829 26.073 18.7007 26.073 18.576Z"
          fill="black"
          style={{fill: 'black', fillOpacity: 1}}
        />
      </mask>
      <g mask="url(#mask0_11041_2257)">
        <path
          d="M27.2721 12.7578L27.1511 12.917L27.1541 12.9192L27.2721 12.7578ZM26.1831 12.6807L26.2726 12.8598L26.2789 12.8563L26.1831 12.6807ZM25.8311 12.9778L25.9952 13.0926L26.0007 13.0838L25.8311 12.9778ZM25.4681 12.1087L25.5866 12.2699L25.5886 12.2684L25.4681 12.1087ZM28.1191 12.4058L28.2827 12.2908L28.2817 12.2893L28.1191 12.4058ZM26.8541 16.4098L27.0264 16.308L27.0228 16.3024L26.8541 16.4098ZM26.9421 16.9378L27.1085 17.0487L27.1154 17.0383L27.121 17.0271L26.9421 16.9378ZM26.0621 16.8058L25.9015 16.925L25.9034 16.9274L26.0621 16.8058ZM26.8211 14.2977L26.9508 14.4503L26.9581 14.4434L26.8211 14.2977ZM26.2161 18.2138L26.0698 18.0771L26.065 18.0827L26.2161 18.2138ZM27.0081 18.1478L26.8742 18.2966L26.8815 18.3025L27.0081 18.1478ZM27.7581 13.2308C27.7581 12.9704 27.6132 12.7593 27.3901 12.5963L27.1541 12.9192C27.3124 13.0349 27.3581 13.1391 27.3581 13.2308H27.7581ZM27.3931 12.5985C27.1824 12.4384 26.954 12.3488 26.7111 12.3488V12.7488C26.8496 12.7488 26.9951 12.7985 27.1511 12.917L27.3931 12.5985ZM26.7111 12.3488C26.4883 12.3488 26.2792 12.4005 26.0873 12.5052L26.2789 12.8563C26.4097 12.785 26.5526 12.7488 26.7111 12.7488V12.3488ZM26.0937 12.5019C25.9092 12.5941 25.7594 12.7151 25.6615 12.8717L26.0007 13.0838C26.0494 13.0058 26.1344 12.9289 26.2726 12.8598L26.0937 12.5019ZM25.6673 12.8631C25.5681 13.0047 25.4866 13.1018 25.4226 13.1613C25.35 13.2288 25.3322 13.2178 25.3581 13.2178V13.6178C25.494 13.6178 25.61 13.5333 25.6951 13.4542C25.7887 13.3671 25.8891 13.2443 25.9952 13.0926L25.6673 12.8631ZM25.3581 13.2178C25.2301 13.2178 25.1711 13.1865 25.1431 13.1592C25.116 13.1327 25.0851 13.0777 25.0851 12.9557H24.6851C24.6851 13.1418 24.733 13.3178 24.8636 13.4453C24.9933 13.572 25.1708 13.6178 25.3581 13.6178V13.2178ZM25.0851 12.9557C25.0851 12.7754 25.2126 12.5451 25.5866 12.2699L25.3496 11.9477C24.9463 12.2444 24.6851 12.5787 24.6851 12.9557H25.0851ZM25.5886 12.2684C25.9478 11.9973 26.3134 11.8688 26.6891 11.8688V11.4688C26.2141 11.4688 25.7657 11.6336 25.3476 11.9491L25.5886 12.2684ZM26.6891 11.8688C27.2256 11.8688 27.6418 12.083 27.9565 12.5222L28.2817 12.2893C27.8924 11.7458 27.3553 11.4688 26.6891 11.4688V11.8688ZM27.9555 12.5207C28.1271 12.765 28.2051 13.0006 28.2051 13.2308H28.6051C28.6051 12.9036 28.4925 12.5892 28.2827 12.2908L27.9555 12.5207ZM28.2051 13.2308C28.2051 13.6552 28.0329 14.0755 27.6613 14.4952L27.9609 14.7603C28.3813 14.2853 28.6051 13.7743 28.6051 13.2308H28.2051ZM27.6613 14.4952C27.4952 14.683 27.3293 14.8597 27.1637 15.0253L27.4465 15.3082C27.6183 15.1364 27.7897 14.9538 27.9609 14.7603L27.6613 14.4952ZM27.1637 15.0253C26.9593 15.2297 26.8006 15.405 26.6916 15.5496C26.6372 15.6219 26.5919 15.6908 26.5594 15.7552C26.5286 15.8162 26.5001 15.8908 26.5001 15.9697H26.9001C26.9001 15.9827 26.8968 15.9744 26.9165 15.9354C26.9344 15.8999 26.9647 15.852 27.0111 15.7904C27.1038 15.6673 27.2476 15.5071 27.4465 15.3082L27.1637 15.0253ZM26.5001 15.9697C26.5001 16.1532 26.571 16.3373 26.6854 16.5172L27.0228 16.3024C26.9319 16.1595 26.9001 16.0503 26.9001 15.9697H26.5001ZM26.6819 16.5115C26.7274 16.5886 26.7586 16.6485 26.7778 16.6928C26.7998 16.7435 26.7971 16.7538 26.7971 16.7398H27.1971C27.1971 16.6671 27.1706 16.5931 27.1449 16.5338C27.1164 16.4681 27.0762 16.3923 27.0264 16.308L26.6819 16.5115ZM26.7971 16.7398C26.7971 16.7576 26.7912 16.7923 26.7632 16.8484L27.121 17.0271C27.1663 16.9364 27.1971 16.8393 27.1971 16.7398H26.7971ZM26.7757 16.8269C26.7275 16.8992 26.6639 16.9358 26.5571 16.9358V17.3358C26.7876 17.3358 26.9807 17.2404 27.1085 17.0487L26.7757 16.8269ZM26.5571 16.9358C26.4914 16.9358 26.3781 16.8893 26.2208 16.6841L25.9034 16.9274C26.0834 17.1622 26.3002 17.3358 26.5571 17.3358V16.9358ZM26.2227 16.6865C26.0784 16.4921 26.0091 16.2842 26.0091 16.0578H25.6091C25.6091 16.374 25.7084 16.6648 25.9015 16.925L26.2227 16.6865ZM26.0091 16.0578C26.0091 15.6371 26.1657 15.2516 26.495 14.8955L26.2012 14.624C25.8118 15.0452 25.6091 15.525 25.6091 16.0578H26.0091ZM26.495 14.8955C26.6596 14.7166 26.8119 14.5684 26.9508 14.4503L26.6916 14.1454C26.5372 14.2766 26.3739 14.4363 26.2012 14.624L26.495 14.8955ZM26.9581 14.4434C27.209 14.2075 27.4044 13.9922 27.5384 13.7982C27.6693 13.6087 27.7581 13.4162 27.7581 13.2308H27.3581C27.3581 13.2946 27.3241 13.4047 27.2093 13.5708C27.0976 13.7325 26.9245 13.926 26.6841 14.1521L26.9581 14.4434ZM26.2731 18.5768C26.2731 18.498 26.2999 18.4223 26.3672 18.3447L26.065 18.0827C25.9416 18.2251 25.8731 18.3916 25.8731 18.5768H26.2731ZM26.3623 18.3502C26.4207 18.2876 26.5033 18.2488 26.6341 18.2488V17.8487C26.4129 17.8487 26.2168 17.9197 26.0698 18.0771L26.3623 18.3502ZM26.6341 18.2488C26.7957 18.2488 26.8572 18.2813 26.8742 18.2966L27.1419 17.999C27.0122 17.8823 26.8245 17.8487 26.6341 17.8487V18.2488ZM26.8815 18.3025C26.8792 18.3006 26.8928 18.3106 26.9064 18.3587C26.9198 18.4063 26.9291 18.4772 26.9291 18.5768H27.3291C27.3291 18.4564 27.3183 18.3457 27.2913 18.2503C27.2646 18.1554 27.2177 18.0609 27.1347 17.9929L26.8815 18.3025ZM26.9291 18.5768C26.9291 18.7449 26.8906 18.8336 26.8489 18.8797C26.8105 18.922 26.7409 18.9597 26.6011 18.9597V19.3598C26.8133 19.3598 27.0077 19.3003 27.1453 19.1483C27.2796 19.0001 27.3291 18.7973 27.3291 18.5768H26.9291ZM26.6011 18.9597C26.5453 18.9597 26.4761 18.9349 26.3917 18.8338L26.0845 19.0897C26.2201 19.2526 26.3929 19.3598 26.6011 19.3598V18.9597ZM26.3917 18.8338C26.3004 18.7242 26.2731 18.6397 26.2731 18.5768H25.8731C25.8731 18.7633 25.9558 18.9353 26.0845 19.0897L26.3917 18.8338Z"
          fill="url(#paint2_linear_11041_2257)"
        />
      </g>
      <path
        d="M5.5 17.5H21.5V29.5H12L10 31.5L8 29.5H5.5V17.5Z"
        fill="white"
        stroke="url(#paint3_linear_11041_2257)"
        style={{fill: 'white', fillOpacity: 1}}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.5 25.5H12.5M9.5 21.5H15.5"
        stroke="url(#paint4_linear_11041_2257)"
        stroke-width="2"
        stroke-linecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11041_2257"
          x1="26.5"
          y1="9.5"
          x2="26.5"
          y2="23.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop style={{stopColor: 'black', stopOpacity: 1}} />
          <stop
            offset="1"
            stop-color="#58525E"
            style={{stopColor: '#58525E', stopOpacity: 1}}
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11041_2257"
          x1="26.645"
          y1="11.668"
          x2="26.645"
          y2="19.159"
          gradientUnits="userSpaceOnUse"
        >
          <stop style={{stopColor: 'black', stopOpacity: 1}} />
          <stop
            offset="1"
            stopColor="#58525E"
            style={{stopColor: '#58525E', stopOpacity: 1}}
          />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11041_2257"
          x1="27.0001"
          y1="7.50075"
          x2="27.0001"
          y2="22.5008"
          gradientUnits="userSpaceOnUse"
        >
          <stop style={{stopColor: 'black', stopOpacity: 1}} />
          <stop
            offset="1"
            stopColor="#5E5E5E"
            style={{stopColor: '#5E5E5E', stopOpacity: 1}}
          />
        </linearGradient>
        <linearGradient
          id="paint3_linear_11041_2257"
          x1="13.5"
          y1="17.5"
          x2="13.5"
          y2="31.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop style={{stopColor: 'black', stopOpacity: 1}} />
          <stop
            offset="1"
            stopColor="#58525E"
            style={{stopColor: '#58525E', stopOpacity: 1}}
          />
        </linearGradient>
        <linearGradient
          id="paint4_linear_11041_2257"
          x1="12.5"
          y1="21.5"
          x2="12.5"
          y2="25.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            stopColor="#18161A"
            style={{stopColor: '#18161A', stopOpacity: 1}}
          />
          <stop
            offset="1"
            stopColor="#343138"
            style={{stopColor: '#343138', stopOpacity: 1}}
          />
        </linearGradient>
      </defs>
    </svg>
  );
};
